import type { Dictionary } from './en'

export const de = {
  nav: { features: 'Funktionen', pricing: 'Preis', faq: 'Fragen', account: 'Mein Konto', signIn: 'Anmelden' },

  hero: {
    title: 'Alt-Tab für Ihren Mac',
    tagline: 'macOS wechselt Apps. AppSwitch lässt ⌥Tab Fenster wechseln — alle Fenster, auch die drei Dokumente in derselben App.',
    download: 'Für Mac laden',
    seePricing: 'Preis ansehen',
    note: 'Kostenlos · macOS 15 oder neuer · Apple Silicon und Intel',
    hint: '⌥ halten und Tab drücken — loslassen zum Wechseln',
  },

  features: {
    heading: 'Für alle, die zwanzig Fenster offen haben',
    sub: 'Ein Druck auf ⌥Tab zeigt sie alle. Loslassen, und Sie sind da.',
    items: [
      { title: 'Jedes Fenster, nicht jede App', body: 'Der Umschalter von macOS wechselt zwischen Apps. AppSwitch wechselt zwischen Fenstern — auch den drei Dokumenten in derselben App.' },
      { title: 'Tastatur zuerst', body: '⌥Tab vorwärts, ⌥⇧Tab rückwärts, Pfeiltasten durch das Raster. ⌥ loslassen, und das gewählte Fenster kommt nach vorn.' },
      { title: 'Stiehlt nie den Fokus', body: 'Ihre App bleibt aktiv, bis Sie wirklich wählen. AppSwitch lebt in der Menüleiste, ohne Dock-Symbol im Weg.' },
      { title: 'Live-Vorschauen', body: 'Sehen Sie den echten Inhalt jedes Fensters statt eines allgemeinen App-Symbols. Minimierte Fenster erscheinen direkt im Umschalter.' },
    ],
  },

  pricing: {
    heading: 'Einmal kaufen. Ihnen gehören.',
    sub: 'Der Umschalter selbst ist kostenlos und vollständig — keine Testversion, nichts beschnitten. Pro ergänzt die beiden Funktionen, die eine Lizenz brauchen.',
    free: 'Kostenlos', pro: 'Pro', ribbon: 'Einmalkauf',
    freePrice: '0 €', once: 'einmalig',
    freeSub: 'Alles, um ⌘Tab hinter sich zu lassen.',
    proSub: 'Kein Abo. Nichts verlängert sich, nie.',
    freeList: [
      'Vollständiger Fensterwechsler auf ⌥Tab',
      'Bedienung mit Tastatur und Maus',
      'Raster- und Listenansicht',
      'Menüleisten-App, kein Dock-Symbol',
    ],
    proList: [
      'Alles aus der kostenlosen Version',
      'Live-Vorschauen jedes Fensters',
      'Minimierte Fenster im Umschalter',
      'Zwei Macs pro Lizenz',
    ],
    download: 'Laden', buy: 'AppSwitch Pro holen', buyBusy: 'Kasse wird geöffnet…',
    freeFoot: 'Kein Konto. Keine Karte. Kein Ablaufdatum.',
  },

  faq: {
    heading: 'Fragen',
    items: [
      { q: 'Warum braucht AppSwitch Bedienungshilfen-Zugriff?', a: 'Nur so lässt macOS eine App ⌥Tab vor allen anderen abfangen, Ihre Fenster auflisten und eines nach vorn holen. Ohne ihn funktioniert die App überhaupt nicht. Sie erteilen ihn selbst in den Systemeinstellungen und können ihn jederzeit widerrufen.' },
      { q: 'Ist das ein Abonnement?', a: 'Nein. AppSwitch Pro ist ein Einmalkauf. Nichts verlängert sich, nichts wird erneut abgebucht, und Updates der aktuellen Hauptversion sind enthalten.' },
      { q: 'Auf wie vielen Macs darf ich es nutzen?', a: 'Zwei pro Lizenz. Sie können einen Platz jederzeit im Kontobereich oder in der App freigeben — ein Rechnerwechsel ist nie ein Supportfall.' },
      { q: 'Werden meine Fenstertitel irgendwohin gesendet?', a: 'Nein. Kein Fensterinhalt, kein Fenstertitel und kein Tastendruck verlässt Ihren Mac. Die einzige Netzwerkanfrage ist die Lizenzprüfung, und nur wenn Sie Pro gekauft haben. Die kostenlose Version geht nie ins Netz.' },
      { q: 'Welche macOS-Versionen werden unterstützt?', a: 'macOS 15 oder neuer, auf Apple Silicon und Intel.' },
    ],
  },

  listMode: {
    heading: 'Zwei Arten, Ihre Fenster zu sehen',
    sub: 'Umschalten über die Menüleiste, oder mit der Taste , während der Umschalter offen ist.',
    grid: { title: 'Raster, mit Vorschauen', body: 'Miniaturen des echten Fensterinhalts. Ideal, wenn Sie ein Fenster an dem erkennen, was darin steht.' },
    list: { title: 'Liste, mit vollen Titeln', body: 'Eine dichte Spalte, in der jeder Fenstertitel vollständig steht. Ideal für zwanzig Terminals oder Dateien, deren Namen sich erst am Ende unterscheiden.' },
  },

  footer: { terms: 'Nutzungsbedingungen', privacy: 'Datenschutz' },

  consent: {
    text: 'Wir nutzen Google Analytics, um zu verstehen, welche Seiten nützlich sind. Ohne Ihre Zustimmung wird nichts gemessen. Siehe unsere',
    privacyLink: 'Datenschutzerklärung',
    accept: 'Akzeptieren', decline: 'Ablehnen',
  },
} satisfies Dictionary
